import { useFeatureFlagVariantKey } from "posthog-js/react";
import { useOrganization } from "~hooks/useOrganization";
import { FeatureFlagKeyEnum } from "~graphql/sdk";

export type CheckoutVariant = "spc" | "legacy";

export const useCheckoutVariant = (): CheckoutVariant => {
  const { hasFeature } = useOrganization();

  const orgHasSinglePage = hasFeature(FeatureFlagKeyEnum.SinglePageCheckout);

  // Gate 2: PostHog experiment variant — 'control', 'spc', or undefined
  const posthogVariant = useFeatureFlagVariantKey("single-page-checkout");

  if (!orgHasSinglePage) return "legacy";
  if (posthogVariant === "spc") return "spc";
  return "legacy"; // 'control' or undefined both fall back to legacy
};
